import React, { Component } from "react";

import {
  Card,
  Button,
  Table,
  Tooltip,
  Select,
  Input,
  BackTop,
  Modal,
  Tag,
  Switch,
} from "antd";

import { connect } from "react-redux";
import {
  req_page_tqa_work_d_list,
  req_downloadfile_tqa_worker,
} from "../../api";

import {
  API_BASE,
  PAGE_SIZE,
  SORT_FIELD_NAME,
  SORT_UP_DOWN,
} from "../../utils/contrains";
import { usrRole } from "../../utils/dataUtil";
import { getNowAcademicYear } from "../../utils/dateUtil";

import DepartmentQuailtyD01 from "./department-quailty-d01";
import DepartmentQuailtyD02 from "./department-quailty-d02";
import DepartmentQuailtyD03 from "./department-quailty-d03";
import DepartmentQuailtyD04 from "./department-quailty-d04";
import DepartmentQuailtyD05 from "./department-quailty-d05";
import DepartmentQuailtyD06 from "./department-quailty-d06";
import DepartmentQuailtyD07 from "./department-quailty-d07";
import DepartmentQuailtyD08 from "./department-quailty-d08";
import DownloadTemplateModal from "./download-template-modal";

class ManageWorkLevelDList extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    deviceWidth: 0,
    loading: false,
    userLevel: "NORMAL",
    items: [],
    item: {},
    pagination: {
      current: 1,
      pageSize: PAGE_SIZE,
      total: 0,
    },
    columnSort: SORT_FIELD_NAME,
    orderBy: SORT_UP_DOWN,
    searchField: "NONE",
    searchValue: "",
    filterStatus: "",
    switchStatus: true,
    domnloadFile: "",
    academicYear: getNowAcademicYear(new Date()),
    isD01Modal: false,
    isD02Modal: false,
    isD03Modal: false,
    isD04Modal: false,
    isD05Modal: false,
    isD06Modal: false,
    isD07Modal: false,
    isD08Modal: false,
    isTemplateModal: false,
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
  }

  componentDidMount() {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
    this.api_page_items(1);
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_page_items = (current) => {
    this.current = current; // 保存當前頁，給其他方法可看到
    const { pageSize } = this.state.pagination;
    const {
      searchField,
      searchValue,
      columnSort,
      orderBy,
      filterStatus,
      academicYear,
    } = this.state;
    const { token, userCode, role } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });

    this.api_page_run(
      userCode,
      userLevel,
      current,
      pageSize,
      columnSort,
      orderBy,
      searchField,
      searchValue,
      filterStatus,
      academicYear,
      token
    );
  };

  api_page_run = async (
    userCode,
    userLevel,
    current,
    pageSize,
    columnSort,
    orderBy,
    searchField,
    searchValue,
    filterStatus,
    academicYear,
    token
  ) => {
    this.setState({ loading: true });
    const result = await req_page_tqa_work_d_list(
      userCode,
      userLevel,
      current,
      pageSize,
      columnSort,
      orderBy,
      searchField,
      searchValue,
      filterStatus,
      academicYear,
      token
    );
    //console.log(result);
    if (result.total > 0) {
      const { total } = result;
      const items = result.data;
      const pagination = {
        current: this.current,
        pageSize: this.state.pagination.pageSize,
        total,
      };
      this.setState({ items, pagination });
    } else {
      const items = [];
      const pagination = {
        current: 1,
        pageSize: this.state.pagination.pageSize,
        total: 0,
      };
      this.setState({ items, pagination });
    }
    this.setState({ loading: false });
  };

  api_downloadfile_items = async () => {
    const { userLevel, searchField, searchValue, filterStatus, academicYear } =
      this.state;
    const { token, userCode } = this.props.user;

    // download file data
    const fileUrl = await req_downloadfile_tqa_worker(
      userCode,
      userLevel,
      searchField,
      searchValue,
      filterStatus,
      academicYear,
      token
    );

    // download file link
    let a = document.createElement("a");
    a.href = API_BASE + fileUrl;
    a.target = "_blank";
    a.download = "品保作業人員清單";
    a.click();
  };

  // 數據配置設定 //////////////////////////////////////////////

  style_switch_text_tag(column) {
    let ans = "其他";
    switch (column) {
      case "A":
        ans = "學院"; // 學院
        break;
      case "B": // 中心
        ans = "中心";
        break;
      case "C":
        ans = "學系"; // 學系
        break;
      case "D":
        ans = "碩班"; //碩班
        break;
      default:
        // OTHER
        break;
    }
    return ans;
  }

  style_switch_color_tag(column) {
    let ans = "gold";
    switch (column) {
      case "A":
        ans = "#87d068"; // 學院
        break;
      case "B": // 中心
        ans = "#108ee9";
        break;
      case "C": // 學系
        ans = "magenta";
        break;
      case "D":
        ans = "#f50"; // 碩班
        break;
      default:
        ans = "gold";
        break;
    }
    return ans;
  }

  // 操作互動處理 //////////////////////////////////////////////

  resize() {
    this.setState({ deviceWidth: window.innerWidth });
  }

  handle_page_size_change = (current, size) => {
    //console.log(size)
    this.setState(
      {
        pagination: {
          current: current,
          pageSize: size,
        },
      },
      () => {
        this.api_page_items(current);
      }
    );
  };

  handle_table_change = (pagination, filters, sorter, extra) => {
    if (filters) {
      const status = [...Object.values(filters).filter(Boolean)][0];
      if (status) {
        this.setState({ filterStatus: status }, () => {
          this.api_page_items(pagination.current);
        });
      } else {
        this.setState({ filterStatus: "" }, () => {
          this.api_page_items(pagination.current);
        });
      }
    } else {
      this.api_page_items(pagination.current);
    }
  };

  handle_data_refresh = () => {
    this.api_page_items(this.current);
  };

  handle_ui_field_change = (target_key, target_field, e) => {
    const value = e.target.value;
    const item = {
      activityNid: target_key,
      setPoints: value,
      condition: target_field,
    };
    //console.log(target_key)
    this.api_modify_item(item);
  };

  handle_switch_change = (checked) => {
    // console.log(checked);
    this.setState({ switchStatus: checked }, () => {
      this.api_page_items(this.current);
    });
  };

  handle_show_ui_modal = (modal, item) => {
    switch (modal) {
      case "D01":
        this.setState({ isD01Modal: true, item });
        break;
      case "D02":
        this.setState({ isD02Modal: true, item });
        break;
      case "D03":
        this.setState({ isD03Modal: true, item });
        break;
      case "D04":
        this.setState({ isD04Modal: true, item });
        break;
      case "D05":
        this.setState({ isD05Modal: true, item });
        break;
      case "D06":
        this.setState({ isD06Modal: true, item });
        break;
      case "D07":
        this.setState({ isD07Modal: true, item });
        break;
      case "D08":
        this.setState({ isD08Modal: true, item });
        break;
      case "Template":
        this.setState({ isTemplateModal: true, item });
        break;
      default:
    }
  };

  /////////////////////////////////////////////////////////////
  init_columns = () => {
    const academicYear = getNowAcademicYear(new Date());
    this.setState({ academicYear });
    this.columns = [
      {
        title: "分類",
        width: 20,
        responsive: ["md"],
        render: (item) => {
          const { WorkTypeCode } = item;
          return (
            <div className="text-center">
              <Tag color={this.style_switch_color_tag(WorkTypeCode)}>
                {this.style_switch_text_tag(WorkTypeCode)}
              </Tag>
            </div>
          );
        },
      },
      {
        title: "學年度",
        dataIndex: "AcademicYear",
        width: 20,
        responsive: ["md"],
      },
      {
        title: "單位",
        dataIndex: "DepartmentName",
        width: 40,
        render: (field) => {
          return (
            <div>
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "負責老師",
        width: 30,
        responsive: ["md"],
        render: (item) => {
          const { AuthorName } = item;
          return (
            <div className="text-center">
              <span style={{ fontSize: "1.3em" }}> {AuthorName}</span>
            </div>
          );
        },
      },
      {
        title: "",
        dataIndex: "",
        width: 70,
        render: (item) => {
          const { switchStatus } = this.state;
          const {
            D01Status,
            D02Status,
            D03Status,
            D04Status,
            D05Status,
            D06Status,
            D07Status,
            D08Status,
            TemplateTotal,
          } = item;
          return (
            <>
              {" "}
              <Tooltip title="下載當年度手冊範本">
                {TemplateTotal > 0 ? (
                  <button
                    type="button"
                    className="btn btn-outline-danger btn-sm"
                    onClick={() => this.handle_show_ui_modal("Template", item)}
                  >
                    <i className="fa fa-align-justify"></i>
                    <span style={{ marginLeft: "2px" }}>
                      {" "}
                      {switchStatus ? "年度手冊範本" : "範本"}
                    </span>
                  </button>
                ) : (
                  ""
                )}
              </Tooltip>
              <Tooltip title="系碩士班教育目標表">
                <button
                  type="button"
                  className={
                    D01Status === "NONE"
                      ? "btn btn-outline-dark btn-sm"
                      : D01Status === "DONE"
                      ? "btn btn-outline-success btn-sm disabled"
                      : "btn btn-outline-primary btn-sm"
                  }
                  onClick={() => this.handle_show_ui_modal("D01", item)}
                >
                  <i className="fa fa-align-justify"></i>
                  <span style={{ marginLeft: "2px" }}>
                    {" "}
                    {switchStatus ? "C01-系碩士班教育目標表" : "C01"}
                  </span>
                </button>
              </Tooltip>
              <Tooltip title="系碩士班學生基本素養表">
                <button
                  type="button"
                  className={
                    D02Status === "NONE"
                      ? "btn btn-outline-dark btn-sm"
                      : D02Status === "DONE"
                      ? "btn btn-outline-success btn-sm disabled"
                      : "btn btn-outline-primary btn-sm"
                  }
                  onClick={() => this.handle_show_ui_modal("D02", item)}
                >
                  <i className="fa fa-align-justify"></i>
                  <span style={{ marginLeft: "2px" }}>
                    {" "}
                    {switchStatus ? "C02-系碩士班學生基本素養表" : "C02"}
                  </span>
                </button>
              </Tooltip>
              <Tooltip title="系碩士班學生核心能力表">
                <button
                  type="button"
                  className={
                    D03Status === "NONE"
                      ? "btn btn-outline-dark btn-sm"
                      : D03Status === "DONE"
                      ? "btn btn-outline-success btn-sm"
                      : "btn btn-outline-primary btn-sm"
                  }
                  onClick={() => this.handle_show_ui_modal("D03", item)}
                >
                  <i className="fa fa-align-justify"></i>
                  <span style={{ marginLeft: "2px" }}>
                    {" "}
                    {switchStatus ? "C03-系碩士班學生核心能力表" : "C03"}
                  </span>
                </button>
              </Tooltip>
              <Tooltip title="系碩士班教學品保評量計畫">
                <button
                  type="button"
                  className={
                    D04Status === "NONE"
                      ? "btn btn-outline-dark btn-sm"
                      : D04Status === "DONE"
                      ? "btn btn-outline-success btn-sm"
                      : "btn btn-outline-primary btn-sm"
                  }
                  onClick={() => this.handle_show_ui_modal("D04", item)}
                >
                  <i className="fa fa-align-justify"></i>
                  <span style={{ marginLeft: "2px" }}>
                    {" "}
                    {switchStatus ? "C04-系碩士班教學品保評量計畫" : "C04"}
                  </span>
                </button>
              </Tooltip>
              <Tooltip title="校、學院與系教育目標對照表">
                <button
                  type="button"
                  className={
                    D05Status === "NONE"
                      ? "btn btn-outline-dark btn-sm"
                      : D05Status === "DONE"
                      ? "btn btn-outline-success btn-sm"
                      : "btn btn-outline-primary btn-sm"
                  }
                  onClick={() => this.handle_show_ui_modal("D05", item)}
                >
                  <i className="fa fa-align-justify"></i>
                  <span style={{ marginLeft: "2px" }}>
                    {switchStatus ? "C05-校、學院與系教育目標對照表" : "C05"}
                  </span>
                </button>
              </Tooltip>
              <Tooltip title="學院與碩士班學生核心能力關聯表">
                <button
                  type="button"
                  className={
                    D06Status === "NONE"
                      ? "btn btn-outline-dark btn-sm"
                      : D06Status === "DONE"
                      ? "btn btn-outline-success btn-sm"
                      : "btn btn-outline-primary btn-sm"
                  }
                  onClick={() => this.handle_show_ui_modal("D06", item)}
                >
                  <i className="fa fa-align-justify"></i>
                  <span style={{ marginLeft: "2px" }}>
                    {" "}
                    {switchStatus
                      ? "C06-學院與碩士班學生核心能力關聯表"
                      : "C06"}
                  </span>
                </button>
              </Tooltip>
              <Tooltip title="系碩士班教育目標和學生基本素養與核心能力關聯表">
                <button
                  type="button"
                  className={
                    D07Status === "NONE"
                      ? "btn btn-outline-dark btn-sm"
                      : D07Status === "DONE"
                      ? "btn btn-outline-success btn-sm disabled"
                      : "btn btn-outline-primary btn-sm"
                  }
                  onClick={() => this.handle_show_ui_modal("D07", item)}
                >
                  <i className="fa fa-align-justify"></i>
                  <span style={{ marginLeft: "2px" }}>
                    {switchStatus
                      ? "C07-系碩士班教育目標和學生基本素養與核心能力關聯表"
                      : "C07"}
                  </span>
                </button>
              </Tooltip>
              <Tooltip title="系碩士班培育目標人才表">
                <button
                  type="button"
                  className={
                    D08Status === "NONE"
                      ? "btn btn-outline-dark btn-sm"
                      : D08Status === "DONE"
                      ? "btn btn-outline-success btn-sm"
                      : "btn btn-outline-primary btn-sm"
                  }
                  onClick={() => this.handle_show_ui_modal("D08", item)}
                >
                  <i className="fa fa-align-justify"></i>
                  <span style={{ marginLeft: "2px" }}>
                    {" "}
                    {switchStatus ? "C08-系碩士班培育目標人才表" : "C08"}
                  </span>
                </button>
              </Tooltip>
            </>
          );
        },
      },
    ];
  };

  render() {
    const {
      loading,
      item,
      items,
      pagination,
      searchField,
      searchValue,
      academicYear,
      isD01Modal,
      isD02Modal,
      isD03Modal,
      isD04Modal,
      isD05Modal,
      isD06Modal,
      isD07Modal,
      isD08Modal,
      isTemplateModal,
    } = this.state;
    const title = (
      <>
        <Input
          placeholder="學年"
          style={{ width: 55, margin: "0 5px", backgroundColor: "LightYellow" }}
          value={academicYear}
          onChange={(event) =>
            this.setState({ academicYear: event.target.value })
          }
        />
        <Select
          value={searchField}
          style={{ width: 120, backgroundColor: "LightCyan" }}
          onChange={(value) => this.setState({ searchField: value })}
        >
          <Select.Option value="NONE">搜索條件</Select.Option>
          <Select.Option value="DepartmentName">單位</Select.Option>
        </Select>
        <Input
          placeholder="關鍵字"
          style={{ width: 80, margin: "0 5px", backgroundColor: "LightYellow" }}
          value={searchValue}
          onChange={(event) =>
            this.setState({ searchValue: event.target.value })
          }
        />
        <Button type="primary" onClick={() => this.api_page_items(1)}>
          <i className="fas fa-search element-hidden"></i>
          <span style={{ marginLeft: "4px" }}>查詢</span>
        </Button>{" "}
        <Tooltip placement="top" title="重新整理">
          <Button type="primary" onClick={() => this.handle_data_refresh()}>
            <i className="fas fa-sync-alt"></i>
          </Button>
        </Tooltip>
      </>
    );
    return (
      <Card title={title}>
        <Switch
          checkedChildren="代碼模式"
          unCheckedChildren="文字模式"
          onChange={this.handle_switch_change}
        />
        <Table
          bordered
          scroll={{ y: 480 }}
          loading={loading}
          rowKey="Id"
          dataSource={items}
          onChange={this.handle_table_change}
          pagination={{
            ...pagination,
            responsive: true,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: [5, 10, 20, 50, 100],
            onShowSizeChange: this.handle_page_size_change,
          }}
          columns={this.columns}
        />
        <Modal
          destroyOnClose={true}
          visible={isTemplateModal}
          width={"60%"}
          onOk={() => {
            this.setState({ isTemplateModal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isTemplateModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <DownloadTemplateModal department={item} />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isD01Modal}
          width={"80%"}
          onOk={() => {
            this.setState({ isD01Modal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isD01Modal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <DepartmentQuailtyD01 manual={item} />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isD02Modal}
          width={"80%"}
          onOk={() => {
            this.setState({ isD02Modal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isD02Modal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <DepartmentQuailtyD02 manual={item} />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isD03Modal}
          width={"80%"}
          onOk={() => {
            this.setState({ isD03Modal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isD03Modal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <DepartmentQuailtyD03 manual={item} />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isD04Modal}
          width={"80%"}
          onOk={() => {
            this.setState({ isD04Modal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isD04Modal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <DepartmentQuailtyD04 manual={item} />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isD05Modal}
          width={"80%"}
          onOk={() => {
            this.setState({ isD05Modal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isD05Modal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <DepartmentQuailtyD05 manual={item} />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isD06Modal}
          width={"80%"}
          onOk={() => {
            this.setState({ isD06Modal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isD06Modal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <DepartmentQuailtyD06 manual={item} />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isD07Modal}
          width={"80%"}
          onOk={() => {
            this.setState({ isD07Modal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isD07Modal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <DepartmentQuailtyD07 manual={item} />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isD08Modal}
          width={"80%"}
          onOk={() => {
            this.setState({ isC08Modal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isC08Modal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <DepartmentQuailtyD08 manual={item} />
        </Modal>
        <BackTop visibilityHeight="80" />
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(ManageWorkLevelDList);
